import { Img } from 'openimg/react'
import { useEffect, useRef, useState, type ComponentProps } from 'react'
import { cn } from '#app/utils/misc.tsx'

export function UserAvatar({
	src,
	alt,
	className,
	...props
}: ComponentProps<typeof Img>) {
	const [failedSrc, setFailedSrc] = useState<string>()
	const [loadedSrc, setLoadedSrc] = useState<string>()
	const container = useRef<HTMLSpanElement>(null)
	useEffect(() => {
		const image = container.current?.querySelector('img')
		if (image?.complete) {
			if (image.naturalWidth === 0) setFailedSrc(src)
			else setLoadedSrc(src)
		}
	}, [src])
	const showPhoto = src && src !== '/img/user.png' && failedSrc !== src
	const initials = (alt || '?')
		.trim()
		.split(/\s+/)
		.map((part) => part[0])
		.filter(Boolean)
	const label =
		initials.length > 1 ? `${initials[0]}${initials.at(-1)}` : initials[0]
	return (
		<span
			ref={container}
			className={cn(
				'bg-muted text-muted-foreground relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold',
				className,
			)}
			role="img"
			aria-label={alt}
			aria-hidden={props['aria-hidden']}
		>
			<span aria-hidden="true">{label?.toUpperCase()}</span>
			{showPhoto ? (
				<Img
					{...props}
					src={src}
					alt=""
					aria-hidden="true"
					className={cn(
						'absolute inset-0 size-full object-cover',
						loadedSrc !== src && 'opacity-0',
					)}
					onLoad={() => setLoadedSrc(src)}
					onError={() => setFailedSrc(src)}
				/>
			) : null}
		</span>
	)
}
